import React, { useRef, useEffect, useState } from "react";
import useHttp from "../../../hooks/use-http";
import moment from "moment";

const HarvestDashboard = () => {
  const [regionId, setRegionId] = useState();
  const [regionData, setRegionData] = useState([]);
  const [data, setData] = useState([]);

  const { sendRequest: getRegion } = useHttp();
  useEffect(() => {
    getRegion(
      {
        url: `/api/procurementRegionList/?orgId=${localStorage.getItem(
          "orgId"
        )}`,
      },
      (data) => {
        setRegionData(data.data);
      }
    );
  }, [getRegion]);

  const handleFDateChange = (e) => {
    setSelectedFromDate(e.target.value);
  };
  const handleTDateChange = (e) => {
    setSelectedToDate(e.target.value);
  };

  const currentDate = new Date().toISOString().slice(0, 10);
  var d = new Date();
  d.setDate(d.getDate() - 30);

  const fromDate = d.toISOString().slice(0, 10);
  const [selectedFromDate, setSelectedFromDate] = useState(fromDate);

  const toDate = new Date().toISOString().slice(0, 10);

  const [selectedToDate, setSelectedToDate] = useState(toDate);
  const { sendRequest: getHarvestData } = useHttp();

  const fillHarvestData = (regionId) => {
    var urlfilter = "";

    urlfilter =
      urlfilter + `&fromDate=${moment(selectedFromDate).format("DD/MM/YYYY")}`;
    urlfilter = urlfilter + `&toDate=${moment(toDate).format("DD/MM/YYYY")}`;

    if (regionId > 0) {
      urlfilter = urlfilter + `&regionId=${regionId}`;
    }

    var url = `/api/cropwiseProcurementreports/?orgId=${localStorage.getItem(
      "orgId"
    )}${urlfilter} `;

    getHarvestData(
      {
        url: url,
      },
      (data) => {
        console.log("reportdata", data);
        setData(data.cropwiseProcurement);
      }
    );
  };

  useEffect(() => {
    fillHarvestData(0);
  }, [getHarvestData]);

  return (
    <>
      <div className="content-wrapper">
        <div className="row mx-2">
          <div className="col-6">
            <br />
            <label className="card-title">
              {" "}
              &nbsp; &nbsp;Harvest Dashboard{" "}
            </label>{" "}
          </div>
        </div>

        <section className="content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-body">
                    <div className="row">
                      <div className="col-md-3">
                        <div className="form-group">
                          <label>Region</label>
                          <select
                            id="regionId"
                            className="form-control"
                            value={regionId}
                            onChange={(e) => setRegionId(e.target.value)}
                          >
                            <option value="">All Region</option>
                            {regionData &&
                              regionData.map((x) => (
                                <option key={x.regionId} value={x.regionId}>
                                  {x.regionName}
                                </option>
                              ))}
                          </select>
                        </div>
                      </div>
                      <div className="col-md-2">
                        <div className="form-group">
                          {" "}
                          <label htmlFor={"from_date"}>{"From Date"}</label>
                          <input
                            type={"date"}
                            id={"date"}
                            required
                            className="form-control"
                            max={currentDate}
                            value={selectedFromDate}
                            onChange={handleFDateChange}
                          />
                        </div>
                      </div>
                      <div className="col-md-2">
                        <div className="form-group">
                          <label htmlFor={"to_date"}>{"To Date"}</label>

                          <input
                            type={"date"}
                            id={"date"}
                            required
                            // ref={(el) => (frmRef.current["pdate"] = el)}
                            className="form-control"
                            max={currentDate}
                            value={selectedToDate}
                            onChange={handleTDateChange}
                          />
                        </div>
                      </div>
                      <div className="col-md-2">
                        <div className="form-group">
                          <label>&nbsp;</label>
                          <button
                            className="form-control btn btn-sm btn-primary"
                            onClick={(e) => {
                              fillHarvestData(regionId);
                            }}
                          >
                            Submit
                          </button>
                        </div>
                      </div>
                    </div>

                    <div className="row"></div>
                  </div>
                </div>
                <div className="card mb-3">
                  <div className="card-body">
                    <table
                      className="table text-center"
                      style={{
                        border: "2px solid grey",
                        background: "#F0F8FF",
                      }}
                    >
                      <tbody>
                        {data &&
                          data.map((itm, i) => {
                            return (
                              <tr
                                key={i}
                                className=""
                                style={{ border: "2px solid pink" }}
                              >
                                <td>
                                  <div className="info-box">
                                    <div className="info-box-content">
                                      <span className="info-box-text">
                                        <img
                                          src={`${process.env.REACT_APP_FILE_URL}${itm.cropProfileUrl}`}
                                          className="user-image img-circle"
                                          width="60"
                                          height="60"
                                          alt="User Image"
                                        />
                                        <br />
                                      </span>
                                      <span className="info-box-number">
                                        {itm.cropName}
                                      </span>
                                    </div>
                                  </div>
                                </td>
                                <td>
                                  {" "}
                                  <div className="info-box">
                                    <div className="info-box-content">
                                      <span className="info-box-number">
                                        <i className="fas fa-box"></i>
                                        <br /> {itm.totalQuantity}{" "}
                                        {itm.unitAbbreviation}
                                        <br />
                                      </span>
                                      <span className=" info-box-text">
                                        Produced
                                      </span>
                                    </div>
                                  </div>
                                </td>
                                <td>
                                  {" "}
                                  <div className="info-box">
                                    <div className="info-box-content">
                                      <span className="info-box-number">
                                      <i className="fas fa-dollar-sign"></i>
                                        <br /> {itm.totalHarvestCost}
                                        <br />
                                      </span>
                                      <span className=" info-box-text">
                                        Produce Cost
                                      </span>
                                    </div>
                                  </div>
                                </td>
                                <td>
                                  {" "}
                                  <div className="info-box">
                                    <div className="info-box-content">
                                      <span className="info-box-text">
                                        <i className="fas fa-cogs"></i>
                                        <br /> Machinery Cost <br />
                                      </span>
                                      <span className="info-box-number">
                                        {itm.machineCost}
                                      </span>
                                    </div>
                                  </div>
                                </td>
                                <td>
                                  <div className="info-box">
                                    <div className="info-box-content">
                                      <span className="info-box-text">
                                        <i className="fas fa-users"></i>
                                        <br /> Labour Cost <br />
                                      </span>
                                      <span className="info-box-number">
                                        {itm.totalLabourCost}
                                      </span>
                                    </div>
                                  </div>
                                </td>
                                <td>
                                  {" "}
                                  <div className="info-box">
                                    <div className="info-box-content">
                                      <span className="info-box-text">
                                        <i className="fas fa-clock"></i>
                                        <br /> Labour Hours
                                        <br />
                                      </span>
                                      <span className="info-box-number">
                                        {itm.totalLaboursHours}
                                      </span>
                                    </div>
                                  </div>
                                </td>
                              </tr>
                            );
                          })}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default HarvestDashboard;
